import {
  ArrayToFilterListItemBuilder,
  asDate,
  FieldMetadataCollection,
  FieldMetadataCollectionBuilder,
  FilterFieldProvider,
  FilterOperators,
  mapDate,
} from "@feature/common";
import {Field} from "ngx-angular-query-builder";
import {User} from "../models/user";

export class MciUserFilterFieldProvider
  implements FilterFieldProvider {

  private readonly fieldMetaDataCollection = new FieldMetadataCollection();

  constructor(
    private readonly data: User[]
  ) {
    const columnDataBuilder = new ArrayToFilterListItemBuilder(data ?? []);

    const addStringProp = (k: string) =>
      columnDataBuilder.forProperty(k, k as keyof User, (user: User) => user[k]);

    const addDateProp = (k: string) =>
      columnDataBuilder.add(k, (x: any) => asDate(x[k]), mapDate(k));

    addStringProp('email');
    addStringProp('role');
    addStringProp('limitedByString');
    addStringProp('status');
    addDateProp('createdDate');
    addDateProp('invitedDate');
    addDateProp('emailConfirmedDate');

    const options = columnDataBuilder.build();

    const fieldMetaDataBuilder = new FieldMetadataCollectionBuilder(this.fieldMetaDataCollection);

    const addStringField = (label: string, optionsName: string) =>
      fieldMetaDataBuilder.add(label, optionsName, 'string', FilterOperators.StringDefaults, options.get(optionsName));

    const addDateField = (label: string, optionsName: string) =>
      fieldMetaDataBuilder.add(label, optionsName, 'date', FilterOperators.DateDefaults, options.get(optionsName));

    addStringField('Email Address', 'email');
    addStringField('User Type', 'role');
    addStringField('Limited to', 'limitedByString');
    addStringField('Status', 'status');
    addDateField('Created Date', 'createdDate');
    addDateField('Invited Date', 'invitedDate');
    addDateField('Email Confirmed Date', 'emailConfirmedDate');
  }

  getFilterFields(): Field[] {
    return this.fieldMetaDataCollection.getFilterFields();
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }

}
